var _circle, _circle2, _circle3, _circle4, _circle5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "url(#paint0_linear_10337_112566)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 105,
    fill: "url(#paint1_linear_10337_112566)",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 85,
    fill: "url(#paint2_linear_10337_112566)",
    fillOpacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 65,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 65,
    fill: "url(#paint3_radial_10337_112566)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 85C102.92 85 85 102.92 85 125C85 147.08 102.92 165 125 165C147.08 165 165 147.08 165 125C165 102.92 147.08 85 125 85ZM125 101C132.72 101 139 107.28 139 115C139 122.72 132.72 129 125 129C117.28 129 111 122.72 111 115C111 107.28 117.28 101 125 101ZM125 157C116.88 157 107.28 153.72 100.44 145.48C107.2 140.2 115.72 137 125 137C134.28 137 142.8 140.2 149.56 145.48C142.72 153.72 133.12 157 125 157Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10337_112566",
    x1: 125,
    y1: 0,
    x2: 125,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A78",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10337_112566",
    x1: 125,
    y1: 20,
    x2: 125,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#003A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A78",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10337_112566",
    x1: 125,
    y1: 40,
    x2: 125,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#003A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A78",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10337_112566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125 125) rotate(90) scale(65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A78",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.02cb2d04860a13a736efac9e99294468.svg";
export { ForwardRef as ReactComponent };